<template>
  <div class="row">
    <div class="col-md-12">
      <div class="box box-primary">
        <div class="box-header with-border">
          <h3 class="box-title">
            {{ $t('string.approvalRate') }}
          </h3>
          <cash-hero-box-tools-action />
        </div>
        <div class="box-body">
          <div class="row">
            <div class="col-xs-12">
              <div class="table-responsive">
                <table class="table table-hover table-bordered">
                  <thead>
                    <tr>
                      <th />
                      <th>{{ $t('label.current') }}</th>
                      <th>{{ $t('label.previous') }}</th>
                      <th>{{ $t('label.percentage') }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{{ $t('string.approvalRate') }}</td>
                      <td>
                        <p class="text-number">
                          {{ currentRate }}%
                        </p>
                      </td>
                      <td>
                        <p class="text-number">
                          {{ preventRate }}%
                        </p>
                      </td>
                      <td>
                        <template v-if="currentRate > preventRate">
                          <span class="description-percentage text-green">
                            <i class="fa fa-caret-up" />
                            <template v-if="preventRate > 0">
                              {{ (((currentRate - preventRate) / preventRate) * 100).toFixed(2) }}%
                            </template>
                            <template v-else>
                              {{ currentRate * 100 }}%
                            </template>
                          </span>
                        </template>
                        <template v-else-if="currentRate === preventRate">
                          <span class="description-percentage text-black">
                            0%
                          </span>
                        </template>
                        <template v-else>
                          <span class="description-percentage text-red">
                            <i class="fa fa-caret-down" />
                            <template v-if="preventRate > 0">
                              {{ ((-1) * ((currentRate - preventRate) / preventRate) * 100).toFixed(2) }}%
                            </template>
                            <template v-else>
                              {{ currentRate * 100 }}%
                            </template>
                          </span>
                        </template>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="col-xs-12">
              <highcharts :options="chartOptions" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import CashHeroBoxToolsAction from '../../../components/CashHeroBoxToolsAction'

export default {
  name: 'CashHeroApprovalRateChart',
  components: {
    CashHeroBoxToolsAction
  },
  data () {
    return {
      isRangeFilter: false,
      preventRate: null,
      currentRate: null,
      chartOptions: {
        title: {
          text: this.$t('string.approvalRate')
        },
        subtitle: {
          text: null
        },
        colors: ['blue'],
        xAxis: {
          categories: [],
          title: {
            enabled: false
          }
        },
        yAxis: {
          title: {
            text: this.$t('string.percentage')
          },
          labels: {
            formatter: function () {
              return this.value
            }
          }
        },
        tooltip: {
          split: true,
          valueSuffix: ' %'
        },
        series: [
          {
            type: 'spline',
            name: this.$t('string.approvalRate'),
            data: []
          }
        ]
      }
    }
  },
  computed: {
    ...mapState({
      type: state => state.dashboard.buttonGroupActive,
      daterange: state => state.dashboard.daterange
    })
  },
  watch: {
    '$i18n.locale' () {
      this.getApprovalRateChart()
      this.chartOptions.title.text = this.$t('string.approvalRate')
      this.chartOptions.subtitle.text = `${this.$t('string.approvalRateDisplayBy:')} ${this.type.label}`
      this.chartOptions.yAxis.title = this.$t('string.percentage')
      this.chartOptions.series[0].name = this.$t('string.approvalRate')
    },
    type () {
      this.getApprovalRateChart()
      this.chartOptions.subtitle.text = `${this.$t('string.approvalRateDisplayBy:')} ${this.type.label}`
    },
    daterange () {
      this.getApprovalRateChart()
      this.chartOptions.subtitle.text = `${this.$t('string.approvalRateDisplayBy:')} ${this.type.label}`
    }
  },
  methods: {
    getApprovalRateChart () {
      let params = {}
      if (this.daterange && this.daterange[0] !== null && this.daterange[1] !== null) {
        this.isRangeFilter = true
        params = {
          type: 'daterange',
          start_date: this.$moment(this.daterange[0]).locale('en').format('YYYY-MM-DD'),
          end_date: this.$moment(this.daterange[1]).locale('en').format('YYYY-MM-DD')
        }
      } else {
        this.isRangeFilter = false
        params = {
          type: this.type.value.toUpperCase()
        }
      }

      this.$axios.post(process.env.VUE_APP_API + '/api/v1/report/dashboard/get-approval-rate-chart', params)
        .then((response) => {
          if (response.data.code === 1) {
            const rates = response.data.data.rates
            this.chartOptions.series[0].data = rates
            this.chartOptions.xAxis.categories = response.data.data.categories

            if (Array.isArray(rates)) {
              if (rates.length >= 2) {
                if (this.isRangeFilter) {
                  this.preventRate = 0
                  this.currentRate = ((rates.reduce((total, item) => total + item, 0)) / rates.length).toFixed(2)
                } else {
                  this.preventRate = rates[rates.length - 2]
                  this.currentRate = rates[rates.length - 1]
                }
              } else {
                this.preventRate = 0
                this.currentRate = rates[0]
              }
            }
          }
        })
    }
  },
  mounted () {
    if (this.type) {
      this.getApprovalRateChart()
      this.chartOptions.subtitle.text = `${this.$t('string.approvalRateDisplayBy:')} ${this.type.label}`
    }
  }
}
</script>

<style scoped>

</style>
